<div
  class="wrapper"
  [class.has-error]="
    (birthdayForm.touched || formControlToSet.touched) &&
    (formControlToSet.invalid ||
      birthdayForm.errors ||
      birthdayForm.get('day').errors ||
      birthdayForm.get('month').errors ||
      birthdayForm.get('year').errors)
  "
  [formGroup]="birthdayForm"
  (click)="selectFirst($event)">
  <div class="form-placehodler">
    <!-- day input  -->
    <input
      type="text"
      class="p-0"
      [class.has-error]="birthdayForm.get('day').errors"
      [placeholder]="'BIRTHDAYINPUT.birthdayDPlaceholder' | alpitranslate"
      inputmode="numeric"
      autocomplete="bday-day"
      formControlName="day"
      (click)="$any($event.target).select()"
      (keydown)="keyDownDay($event)"
      (keyup)="continueOnDay($event)"
      (blur)="birthdayForm.get('day').setValue(prefixNumber(birthdayForm.get('day').value))"
      #day />
  </div>
  <span class="pb-1">
    {{ 'BIRTHDAYINPUT.birthdaySepparator' | alpitranslate }}
  </span>
  <div class="form-placehodler">
    <!-- month input  -->
    <input
      type="text"
      class="p-0"
      [class.has-error]="birthdayForm.get('month').errors"
      [placeholder]="'BIRTHDAYINPUT.birthdayMPlaceholder' | alpitranslate"
      inputmode="numeric"
      autocomplete="bday-month"
      formControlName="month"
      (click)="$any($event.target).select()"
      (keydown)="keyDownMonth($event)"
      (keyup)="continueOnMonth($event)"
      (blur)="birthdayForm.get('month').setValue(prefixNumber(birthdayForm.get('month').value))"
      #month />
  </div>
  <span class="pb-1">
    {{ 'BIRTHDAYINPUT.birthdaySepparator' | alpitranslate }}
  </span>
  <div class="form-placehodler">
    <!-- year input  -->
    <input
      type="text"
      [class.has-error]="birthdayForm.get('year').errors"
      [placeholder]="'BIRTHDAYINPUT.birthdayYPlaceholder' | alpitranslate"
      inputmode="numeric"
      class="wide p-0"
      autocomplete="bday-year"
      formControlName="year"
      (click)="$any($event.target).select()"
      (keydown)="keyDownYear($event)"
      (keyup)="continueOnYear($event)"
      #year />
  </div>
  <label>{{ 'BIRTHDAYINPUT.birthdayLabel' | alpitranslate }}</label>
</div>
<!-- TODO: also check date too old/new leap year stuff -->
@if (
  (birthdayForm.touched || formControlToSet.touched) &&
  (birthdayForm.get('day').errors ||
    birthdayForm.get('month').errors ||
    birthdayForm.get('year').errors ||
    birthdayForm.errors?.dayOfMonthInvalid)
) {
  <span class="help-block has-error" @smoothappear>
    {{ 'BIRTHDAYINPUT.validation.invalid' | alpitranslate }}</span
  >
}
@if (birthdayForm.valid && isBirthday) {
  <span class="help-block">Happy Birthday!</span>
}
@if (birthdayForm.errors?.dateTooNew || birthdayForm.errors?.dateTooOld) {
  <a
    class="help-block"
    [routerLink]="['/SKIHIREENTRY', 'PRODUCTS'] | localize"
    [queryParams]="{ shopId: shopID }"
    [queryParamsHandling]="'merge'"
    @smoothappear
    >{{ 'BIRTHDAYINPUT.wrongAgeCategory' | alpitranslate }}</a
  >
}
